<template>
  <div class="config-page">
    <v-row class="pl-2">
      <v-col cols="12" class="content-col">
        <Form />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from './templates/Form'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Form },
  mixins: [ appdata, utils ]
}
</script>
